export default "__VITE_ASSET__CIfbumBv__"